// extracted by mini-css-extract-plugin
export default {"miniRecuadro":"DataOrganizer_miniRecuadro__6DSHt","icono":"DataOrganizer_icono__V2mzx","confirmacion":"DataOrganizer_confirmacion__pp2I9","title":"DataOrganizer_title__AJVMH"};